import { SlotConfig } from "./ad-config/build-page-config";

export default (slots: SlotConfig[], window) =>
    slots.map((slot) => window.document.querySelector(`#${slot.divId}`)).filter((el) => Boolean(el));
